import React, { useEffect } from "react";
import CookieConsent from "cookie-consent-gdpr";

const CookieConsentComp = () => {
  useEffect(() => {
    CookieConsent.init({
      categories: {
        necessary: {
          enabled: true,
          readOnly: true,
          title: "Strict Necesare",
          description:
            "Cookie-uri esențiale care permit funcționarea corectă a site-ului.",
          cookies: [
            {
              name: "cc_consent",
              provider: "programintrastat.ro",
              purpose: "Tine minte alegerile cookie.",
              expiry: "1 an",
              type: "HTTP Cookie",
            },
          ],
        },

        analytics: {
          enabled: false,
          readOnly: false,
          title: "Analiză",
          description:
            "Ne ajută să înțelegem cum interacționează vizitatorii cu site-ul nostru.",
          cookies: [
            {
              name: "_ga",
              provider: "Google Analytics",
              purpose:
                "Distinge utilizatorii unici prin atribuirea unui identificator generat aleator.",
              expiry: "2 ani",
              type: "HTTP Cookie",
            },
            {
              name: "_ga_YRWPRFR5K1",
              provider: "Google Analytics",
              purpose:
                "Folosit pentru menținerea stării sesiunii și colectarea de date statistice despre utilizare.",
              expiry: "2 ani",
              type: "HTTP Cookie",
            },
          ],
        },

        marketing: {
          enabled: false,
          readOnly: false,
          title: "Marketing",
          description:
            "Utilizate pentru livrarea de reclame personalizate și măsurarea eficienței campaniilor.",
          cookies: [
            {
              name: "_gcl_au",
              provider: "Google Ads",
              purpose:
                "Utilizat de Google Ads pentru a măsura eficiența reclamelor și conversiile.",
              expiry: "1 an",
              type: "HTTP Cookie",
            },
          ],
        },
      },

      privacyPolicyUrl: "/politica-de-confidentialitate",

      preferencesButton: '#setari-cookies',

      texts: {
        bannerTitle: "Folosim cookie-uri",
        bannerDescription:
          "Folosim cookie-uri pentru a îmbunătăți experiența ta pe site, pentru analiză și pentru personalizarea conținutului și a reclamelor.",
        acceptAll: "Acceptă toate",
        rejectAll: "Respinge toate",
        settings: "Setări cookie-uri",
        preferencesTitle: "Preferințe cookie-uri",
        preferencesDescription:
          "Alege ce tipuri de cookie-uri dorești să permiți.",
        save: "Salvează preferințele",
        acceptAllPreferences: "Acceptă toate",
        rejectAllPreferences: "Respinge toate",
        alwaysActive: "Întotdeauna active",
        cookieNameLabel: "Denumire",
        cookieProviderLabel: "Furnizor",
        cookiePurposeLabel: "Scop",
        cookieExpiryLabel: "Expirare",
        cookieTypeLabel: "Tip",
        noCookies: "Nu există cookie-uri de afișat.",
        privacyPolicyLabel: "Politica de confidențialitate",
        poweredBy: "",
      },
    });
  }, []);

  return <></>;
};

export default CookieConsentComp;
